import axios from "axios"
import { normalizeInfluencer } from "./normalizeInfluencer"
import { okara_api } from "../../utils/variables"

// Same UGC/socials-intelligence backend as topInfluencerApi.js, not the main
// `REACT_APP_APIKEY` host - INFLUENCER_PROFILE_API.md's example URL is the
// same backend family as the ranking endpoint.
const UGC_API_BASE_URL = okara_api
const INFLUENCER_PROFILE_ENDPOINT = "/top-influencer/profile/"

const authHeaders = () => {
  const token = localStorage.getItem("authToken")
  return token ? { Authorization: `Bearer ${token}` } : {}
}

// Same shape as topInfluencerApi.js's asApiError, plus `notFound` - a 404
// here is a real, valid answer ("discovery hasn't seen this account yet"),
// never an error state (§1/§6), so callers need to tell it apart from a
// genuine failure without string-matching a message.
const asApiError = (error) => {
  const status = error?.response?.status
  const data = error?.response?.data || {}
  const err = new Error(data.detail || data.error || error.message || "Failed to load this creator's profile.")
  err.status = status
  err.data = data
  err.notFound = status === 404
  return err
}

// §3 - the `influencer` block is the same row shape GET /top-influencer/
// returns, so it gets the same normalization (adds a stable `key`).
const normalizeProfileResponse = (raw) => ({
  ...raw,
  influencer: raw.influencer ? normalizeInfluencer(raw.influencer) : raw.influencer,
})

/**
 * Fetch one creator's covered apps and posts (INFLUENCER_PROFILE_API.md). A
 * profile URL is the only required input - §2 also accepts a bare handle
 * with no host when paired with `platform`, which is what makes a hard
 * refresh of `/influencer-explorer/:platform/:username` (no router state to
 * carry the row's real `profile_url`) resolvable without reconstructing a
 * platform-specific URL format client-side.
 */
export async function fetchInfluencerProfile({ profileUrl, platform, appId, videosPerApp } = {}) {
  if (!profileUrl) throw new Error("profileUrl is required")

  const params = { profile_url: profileUrl }
  if (platform) params.platform = platform
  if (appId) params.app_id = appId
  if (videosPerApp) params.videos_per_app = videosPerApp

  try {
    const response = await axios.get(`${UGC_API_BASE_URL}${INFLUENCER_PROFILE_ENDPOINT}`, {
      params,
      headers: authHeaders(),
    })
    return normalizeProfileResponse(response.data)
  } catch (error) {
    throw asApiError(error)
  }
}
